import { FC } from "react";
import { WithdrawalsHistoryTable } from "./withdrawalsHistoryTable";
import { CardInfo } from "../../components/common/cardInfo/CardInfo";
import '../tranference/withdrawals/drawls/tableDrawls/tabletDrawls.css'


const WithdrawalsHistory: FC<any> = (props) => {
  return (
    <div>
      <h2>Historial</h2>
      <CardInfo message="Cada retiro muestra su estatus actual. Ten en cuenta que los retiros tienen un plazo de hasta 24 horas hábiles para ser procesados."/>
      <WithdrawalsHistoryTable />
    </div>
  );
};

export default WithdrawalsHistory;
